// extracted by mini-css-extract-plugin
export default {"input":"SearchBar_input__+08Rn"};